


















import { Component, Vue, Prop } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
library.add(faQuestionCircle);

@Component({
  name: 'up-form-group'
})
export default class UpFormGroup extends Vue {
  @Prop({ default: 'top' })
  tooltipPlacement!: string;
  @Prop({ default: '' })
  tooltipContent!: string;
  @Prop({ default: 'Label' })
  label!: string;
}
